import React, { Component } from 'react'
import './Status404.less'

class MyComponent extends Component {
  render() {
    return (
      <div className="not-found">
        <p className="error-code">404</p>
        <p className="error-msg">找不到页面</p>
      </div>
    )
  }
}

MyComponent.propTypes = {}

export default MyComponent



// WEBPACK FOOTER //
// ./src/pages/Status404.js